import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['resourceHeader', 'searchInput'];

  connect() {
    console.log('search basic controller connected what');
    this.initializeSearch();
  }

  initializeSearch() {
    const searchInput = this.searchInputTarget;
    if (searchInput) {
      searchInput.addEventListener('input', this.searchResources.bind(this));
    } else {
      console.error('Search input target not found');
    }
  }

  searchResources(event) {
    console.log('searching resources');
    const searchQuery = event.target.value.toLowerCase().trim();
    const resourceHeaders = Array.from(this.resourceHeaderTargets);
    const originalOrder = resourceHeaders.map((header) => header.parentElement);

    // If the search query is empty, reset the resource headers to their original order
    if (searchQuery === '') {
      originalOrder.forEach((header, index) => {
        header.style.display = 'block';
        header.style.order = '';
      });
      return;
    }

    console.log('hi');

    // First, filter out the headers that don't match the search query
    const matchingHeaders = resourceHeaders.filter((header) => {
      const headerText = header.textContent.toLowerCase();
      return headerText.includes(searchQuery);
    });

    // Sort the matching headers based on the closest match
    matchingHeaders.sort((a, b) => {
      const aText = a.textContent.toLowerCase();
      const bText = b.textContent.toLowerCase();
      const aStartIndex = aText.indexOf(searchQuery);
      const bStartIndex = bText.indexOf(searchQuery);
      const aLength = aText.length;
      const bLength = bText.length;

      // Prioritize by start index, then by closeness of match length to query length
      if (aStartIndex !== bStartIndex) {
        return aStartIndex - bStartIndex;
      } else {
        return Math.abs(aLength - searchQuery.length) - Math.abs(bLength - searchQuery.length);
      }
    });

    console.log('matchingheader', matchingHeaders);

    // Reset the display and order for all headers
    originalOrder.forEach((header) => {
      header.style.display = 'none';
      header.style.order = '';
    });

    // Show the matching headers in the sorted order
    matchingHeaders.forEach((header, index) => {
      header.parentElement.style.display = 'block';
      header.parentElement.style.order = index;
    });
  }
}
